import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import { PenLine, Mail } from "lucide-react";

export default function MySchools() {
  const [mine, setMine] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/directory/my-contacts").then((r) => setMine(r.data))
      .catch((e) => { setMine([]); toast.error(apiError(e)); });
  }, []);

  if (mine === null) return <div className="text-sm text-[#78716C] animate-pulse" data-testid="my-schools-loading">Loading your schools…</div>;
  return (
    <div className="space-y-6 max-w-3xl" data-testid="my-schools-page">
      <div>
        <h1 className="font-serif font-bold text-2xl text-navy">My Schools</h1>
        <p className="text-sm text-[#57534E]">Schools you're currently assigned to, synced from the CKingEducation directory. Start a daily log for a school or open a designated contact's email.</p>
      </div>
      {mine.length === 0 && (
        <div className="card p-6 text-sm text-[#78716C]" data-testid="my-schools-empty">
          No active school assignments. Ask an Admin to assign you a school from Admin → Consultants.</div>)}
      {mine.map((s) => (
        <div key={s.dir_id} className="card p-6 space-y-3" data-testid={`my-school-card-${s.dir_id}`}>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <div className="font-serif font-bold text-lg text-navy">{s.name}</div>
              {s.district_name && <div className="text-xs text-[#78716C]">{s.district_name}</div>}
            </div>
            {s.ops?.school_id ? (
              <button className="btn-primary" data-testid={`start-log-${s.dir_id}`}
                onClick={() => navigate(`/log-work?organization_id=${s.ops.organization_id}&school_id=${s.ops.school_id}&engagement_id=${s.ops.engagement_id}`)}>
                <PenLine size={15} /> Start daily log</button>
            ) : (
              <span className="text-xs text-[#92400E]" data-testid={`log-unavailable-${s.dir_id}`}>School record is being prepared — try again shortly.</span>)}
          </div>
          {s.contacts.length === 0 && <div className="text-xs text-[#92400E]">No designated contacts are listed for this school yet.</div>}
          {s.contacts.map((c) => (
            <div key={c.dir_id} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`my-school-contact-${c.dir_id}`}>
              <span className="font-bold text-navy">{c.name || c.email}</span>
              {c.role && <span className="text-xs text-[#78716C]">{c.role.replace(/_/g, " ")}</span>}
              {c.is_primary && <span className="badge-approved">Primary</span>}
              {c.is_additional && <span className="badge-neutral">Coordination</span>}
              <a className="text-xs text-terracotta hover:underline flex items-center gap-1" href={`mailto:${c.email}`}
                data-testid={`my-school-contact-email-${c.dir_id}`}><Mail size={11} />{c.email}</a>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
